import UrlGeneration from "../libs/UrlGeneration";
import searchMain from "./search-main";
import anchorScroll from "./anchorScroll";

export default new (class {
    constructor() {
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            document.body.addEventListener('click', (e) => {
                if (e.target.closest('._pagination-item')) {
                    e.preventDefault();
                    this.onItemClick(e);
                }
                if (e.target.closest('._showmore')) {
                    this.onShowMoreClick(e.target.closest('._showmore'))
                }
            })
        });
    }
    onItemClick(e) {
        const link = e.target.closest('._pagination-item');
        if (link.hasAttribute('data-show-more')) {
            this.onNextPageClick(link);
        } else {
            this.onPageClick(link);
        }
    }

    onShowMoreClick(button) {
        const wrap = button.closest('._pagination');
        let update;
        let data;

        if (wrap.closest('.search-main-results')) {
            const searchForm = searchMain.getForm();
            const formEntries = new FormData(searchForm).entries();
            data = Object.assign(...Array.from(formEntries, ([x,y]) => ({[x]:y})));

            data['page_search_main'] = button.dataset.page;
            data['show_more'] = 1;

            update = {
                'pagination/showmore-item': `#pagination-items-${wrap.dataset.paginationFor}`,
                [wrap.dataset.itemsPartial]: `@#${wrap.dataset.paginationFor}`
            };

        } else {
            update = {
                'pagination/showmore-item': `#pagination-items-${wrap.dataset.paginationFor}`,
                [wrap.dataset.itemsPartial]: `@#${wrap.dataset.paginationFor}`
            };
            data = {
                [wrap.dataset.param]: button.dataset.page
            }

        }

        this.applyPagination(wrap.dataset.handler, update, data);
    }

    onNextPageClick(link) {
        const wrap = link.closest('._pagination')
        let data = {};
        if(!wrap.hasAttribute('data-more-btn-only')) {
            UrlGeneration.remove(wrap.dataset.param);
            UrlGeneration.set(wrap.dataset.param, link.dataset.page);
            UrlGeneration.update();
        }
        else {
            data = {
                "page": link.dataset.page
            }
        }

        const update = {
            'pagination/pagination-items': `#pagination-items-${wrap.dataset.paginationFor}`,
            [wrap.dataset.itemsPartial]: `@#${wrap.dataset.paginationFor}`
        };
        this.applyPagination(wrap.dataset.handler, update, data);
    }

    onPageClick(link) {
        const wrap = link.closest('._pagination')
        UrlGeneration.remove(wrap.dataset.param);
        UrlGeneration.set(wrap.dataset.param, link.dataset.page);
        UrlGeneration.update();
        const update = {
            'pagination/pagination-items': `#pagination-items-${wrap.dataset.paginationFor}`,
            [wrap.dataset.itemsPartial]: `#${wrap.dataset.paginationFor}`
        };
        let onComplete = () => {
            anchorScroll.scrollTo(document.getElementById(wrap.dataset.paginationFor));
        }

        this.applyPagination(wrap.dataset.handler, update, {}, onComplete);
    }

    applyPagination(sHandler, update, data = {}, onComplete) {
        oc.ajax(sHandler, {
            update,
            data,
            complete: () => {
                if (onComplete) onComplete();
            }
        });
    }
})()
